import {Http, URLSearchParams} from '@angular/http';
import {Injectable} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';
import * as moment from 'moment';
import * as _ from 'lodash';
import DataProvider from './dataProvider.service';
import Broadcaster from '../../../app/services/broadcaster.service';

import {Observable} from "rxjs/Rx";
import CypherService from "../cypher.service";
import AuthService from "../auth.service";


@Injectable()
class MeasurementsDataProvider extends DataProvider {

    constructor(http: Http,
                Broadcaster: Broadcaster,
                NotificationsService: NotificationsService,
                cypherService: CypherService,
                private authService: AuthService) {
        super(
            http,
            Broadcaster,
            NotificationsService,
            cypherService
        );
    }


    /**
     * API accepts dates in ISO format
     *
     *
     * @param queryParams
     */
    private datesToISO(queryParams) {
        let toISO = (date: string) => {
            return moment(new Date(date)).utc().format();
        }
        if(queryParams.from) {
            queryParams.from = toISO(queryParams.from);
        }
        if(queryParams.to) {
            queryParams.to = toISO(queryParams.to);
        }
    }

    public getAllForUser(options): Observable<any> {
        let optionsClone = _.cloneDeep(options);
        this.datesToISO(optionsClone.queryParams);
        let params = {};
        if (Object.keys(optionsClone.queryParams).length !== 0) {
            params = {
                search: new URLSearchParams()
            }
            for (let key in optionsClone.queryParams) {
                params['search'].set(key, optionsClone.queryParams[key]);
            }
        }
        return super.get(`${this.baseUri + 'measurementslocationsforusers'}/${this.authService.user.id}`, params).map((res) => res.measurements);
    }

    public getOne(id: string): Observable<any> {
        return super.get(`${this.baseUri + 'measurementlocations'}/${id}/forusers/${this.authService.user.id}`, {});
    }

}

export default MeasurementsDataProvider;


// WEBPACK FOOTER //
// ./src/app/services/dataProviders/measurementsDataProvider.service.ts